import { index as jaMessage } from '@/resources/lang/ja/index'
import { index as enMessage } from '@/resources/lang/en/index'

export const messages = {
  en: enMessage,
  ja: jaMessage,
}
